"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.calculateTimeLeft = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var calculateTimeLeft = function calculateTimeLeft(inputDate) {
  var date = (0, _dayjs.default)(inputDate);
  var remDays = (0, _dayjs.default)(date).diff((0, _dayjs.default)(), 'd');
  date = (0, _dayjs.default)(date).subtract(remDays, 'd');
  var remHours = (0, _dayjs.default)(date).diff((0, _dayjs.default)(), 'h');
  date = (0, _dayjs.default)(date).subtract(remHours, 'h');
  var remMin = (0, _dayjs.default)(date).diff((0, _dayjs.default)(), 'm');
  date = (0, _dayjs.default)(date).subtract(remMin, 'm');
  var remSec = (0, _dayjs.default)(date).diff((0, _dayjs.default)(), 's');
  return {
    days: remDays || '0',
    hours: remHours || '0',
    minutes: remMin || '0',
    seconds: remSec || '0'
  };
};

exports.calculateTimeLeft = calculateTimeLeft;
var _default = calculateTimeLeft;
exports.default = _default;